module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    staticClass: "pt-0"
  }, [_c('v-list', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "dense": "",
      "three-line": "",
      "subheader": ""
    }
  }, [_vm._l((_vm.messages), function(message, index) {
    return [(_vm.isNewDate(message, index)) ? _c('v-subheader', {
      key: ("sub-" + (message.id)),
      staticClass: "overline grey lighten-4"
    }, [_vm._v(_vm._s(_vm.dateformat(message.created_date)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-divider', {
      key: ("dt-div-" + (message.id))
    }), _vm._v(" "), _c('communication-list-item', _vm._g({
      attrs: {
        "item": message
      }
    }, _vm.$listeners)), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (message.id))
    })]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754edffe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/communications/Inbox.vue
// module id = 1470
// module chunks = 9